@if (interaction && interaction.childInteraction) {
  <user-interaction
    [interaction]="interaction.childInteraction"
    [renderingOptions]="renderingOptions$ | async"
    >
    <ng-content></ng-content>
  </user-interaction>
}
